import React from 'react'
import { IMAGE } from '../utils/Theme'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { sidebarAction } from '../redux/SidebarSlice'

const AppSidebar = () => {
    const sidebarShow = useSelector((state) => state.SidebarSlice.isSidebarshow)

    console.log(sidebarShow)
    
    const dispatch = useDispatch()



  return (
    <div className={sidebarShow ? 'sidebar sidebar-dark sidebar-fixed border-end' : 'sidebar sidebar-dark sidebar-fixed border-end hide'}>
        <div className='siderbarlogo'>
            <img src={IMAGE.logo} />
        </div>
        <button className='closeBtn' onClick={()=>{
              dispatch(sidebarAction(false)) 
        }}><FontAwesomeIcon icon={faXmark} /></button>
        <div className='sidebar-nav'>
            <ul>
                <li>
                    <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : undefined)}>Dashboard</NavLink>
                </li>
                
                {/* <li>
                    <NavLink to="/add-trip" className={({ isActive }) => (isActive ? "active" : undefined)}>Book a new ride</NavLink>
                </li> */}
 
                    <li>
                    <NavLink to="/upcoming-ride" className={({ isActive }) => (isActive ? "active" : undefined)}>Upcoming rides</NavLink>
                </li>
                <li>
                    <NavLink to="/ongoing-ride" className={({ isActive }) => (isActive ? "active" : undefined)}>Ongoing rides</NavLink>
                </li>
               
                <li>
                    <NavLink to="/complete-ride" className={({ isActive }) => (isActive ? "active" : undefined)}>Completed rides</NavLink>
                </li>
                <li>
                    <NavLink to="/declined-ride" className={({ isActive }) => (isActive ? "active" : undefined)}>Declined rides</NavLink>
                </li>
                <li>
                    <NavLink to="/my-earning" className={({ isActive }) => (isActive ? "active" : undefined)}>My Earning</NavLink>
                </li>
            </ul>
        </div>
    </div>
  )
}

export default AppSidebar